import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
  IconButton,
  Tooltip
} from '@mui/material';
import { Clear, LocationOn } from '@mui/icons-material';
import { useLocation } from '../context/LocationContext';

const LocationSelector = ({ variant = 'standard', size = 'small', showClearButton = true }) => {
  const {
    selectedLocation,
    locations,
    loading,
    selectLocation,
    clearLocationFilter,
    hasLocationFilter
  } = useLocation();

  const handleChange = (event) => {
    selectLocation(event.target.value || null);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    clearLocationFilter();
  };

  if (variant === 'chip') {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <LocationOn fontSize="small" color="action" />
        <FormControl size={size} sx={{ minWidth: 200 }}>
          <InputLabel>Filter by Location</InputLabel>
          <Select
            value={selectedLocation || ''}
            onChange={handleChange}
            label="Filter by Location"
            disabled={loading}
          >
            <MenuItem value="">All Locations</MenuItem>
            {locations.map(location => (
              <MenuItem key={location.id} value={location.id}>
                {location.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {hasLocationFilter && showClearButton && (
          <Tooltip title="Clear location filter">
            <IconButton size="small" onClick={handleClear}>
              <Clear fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    );
  }

  return (
    <FormControl fullWidth size={size} variant={variant}>
      <InputLabel>Location</InputLabel>
      <Select
        value={selectedLocation || ''}
        onChange={handleChange}
        label="Location"
        disabled={loading}
        startAdornment={<LocationOn sx={{ mr: 1, color: 'action.active' }} />}
      >
        <MenuItem value="">All Locations</MenuItem>
        {locations.map(location => (
          <MenuItem key={location.id} value={location.id}>
            {location.name} - {location.city}, {location.state}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LocationSelector;
